import { render, staticRenderFns } from "./FirstLoginMsgPanel.vue?vue&type=template&id=1061c110&scoped=true"
import script from "./FirstLoginMsgPanel.vue?vue&type=script&lang=js"
export * from "./FirstLoginMsgPanel.vue?vue&type=script&lang=js"
import style0 from "./FirstLoginMsgPanel.vue?vue&type=style&index=0&id=1061c110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1061c110",
  null
  
)

export default component.exports